import { Fragment } from "react";
import { useEffect, useState } from "react";
import Slider from "react-slick";

import ResCard from "../SubComponents/ResCard";

import { ReactComponent as BgOverlay } from "../../../static/svg/podcast.svg";

import AllresHeader from "../SubComponents/AllresHeader";
import {
  Box,
  Card,
  CardMedia,
  Grid,
  IconButton,
  Typography,
  Zoom,
} from "@mui/material";

import PodcastPlayer from "./PodcastPlayer";
import Pagination from "../../UI/Pagination";
import { Link, useLocation } from "react-router-dom";
import MHSubscribe from "../../Layout/MHSubscribe";
import MHFooter from "../../Layout/MHFooter";

import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../../firebase";
import { ResourcesData } from "../../NewLanding/EventGlance";
import AnimatedLoaderText from "../../Common/Loading/AnimatedLoaderText";
import dayjs from "dayjs";
import PodcastSubscribe from "../../NewLanding/PodcastSubscribe";

const PodcastsPage = () => {
  const [podcastData, setPodcastData] = useState<ResourcesData[]>([]); // ← fix

  let [count] = useState(0);
  let [mobileCount] = useState(0);
  const location = useLocation();

  const [noOfElement, setnoOfElement] = useState(1);

  const resOne = podcastData.slice(count, noOfElement);

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(11);

  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentPosts = podcastData.slice(firstPostIndex, lastPostIndex);

  useEffect(() => {
    const getResources = async () => {
      try {
        const collectionRef = collection(db, "caf-podcast-list");
        const querySnapshot = await getDocs(
          query(collectionRef, orderBy("slug", "asc")),
        );

        const data = querySnapshot.docs.map((doc) => ({
          ...(doc.data() as ResourcesData), // ← fix
        }));

        setPodcastData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    getResources();
  }, []);

  const settings = {
    centerMode: true,
    centerPadding: "22px",
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 800,
    autoplay: false,
    // autoplaySpeed: 1500,
    // beforeChange: (current, next) => setSlideIndex(next),
  };

  if (!podcastData)
    return <AnimatedLoaderText text="Fetching data, please wait..." />;

  return (
    <Fragment>
      <AllresHeader
        headerClassName="relative text-center pl-14 md:pl-0 h-[600px] md:h-[450px] lg:h-[500px] w-full bg-lilac-300 overflow-hidden"
        majorClassName="absolute top-14 md:top-12 md:inset-x-[18%] lg:top-24 lg:inset-x-[55%] text-center place-content-center"
        boxClassName="md:place-content-start pl-12 md:pl-0 ml-12 md:ml-0 place-content-start md:overscroll-x-hidden md:gap-2 flex md:pb-4"
        title="Podcast"
        titleInfo="The Home Front Podcast"
        titleInfoclassName="text-center md:text-start mb-6 w-[60%] md:w-full font-columbia text-5xl capitalize font-semibold"
        pageInfo="  Conversations on care, policy, and community-building throughout
            Africa."
        eventSocialClassName="hidden"
        isPodcast
        podClassName="w-[58%] mt-12 md:mt-0 md:w-fit md:absolute md:top-64 md:left-8 md:flex md:gap-32"
        // podClassName2="mx-auto block"
        pageInfoClassName="font-semibold text-center md:text-left w-[70%] -ml-8 md:ml-0 md:w-full text-[12px] font-areaSemi"
        ResIconUrl="https://res.cloudinary.com/mother-honestly/image/upload/v1661824668/image_1_oe6a7y.png"
        BgUrl="https://mh-resources-production.s3.us-west-1.amazonaws.com/blessingAdesiyan.png"
      >
        <BgOverlay
          className="overflow-hidden absolute hidden md:block  top-0 right-0"
          height="500px"
          width="500px"
        />
        <BgOverlay
          className="overflow-hidden absolute md:hidden block scale-y-100 scale-x-100 -rotate-[140deg] -top-48 -left-80"
          height="650px"
          width="720px"
        />
      </AllresHeader>

      <Box className="mx-auto pt-10 bg-white px-4 md:px-24 lg:px-[170px] py-4">
        <Typography
          variant="h1"
          color="primary"
          className="font-areaSemi text-xl text-center py-4"
        >
          Latest Episode
        </Typography>
        {resOne.map((resData, index) => (
          <PodcastPlayer spotifyUrl={resData.url} />
        ))}
      </Box>

      <Box className="bg-gray-300 h-[1px] w-[91.4%] opacity-50 overflow-hidden mx-auto"></Box>

      {/* For Mobile */}
      <Box className="mx-auto pt-10 bg-white px-4 md:px-20 pb-4 block md:hidden overflow-x-hidden">
        <Typography
          variant="h1"
          color="primary"
          className="font-areaSemi text-base md:text-xl text-center py-4"
        >
          Episodes You Might like
        </Typography>
        <Slider {...settings}>
          {podcastData.map((res, index) => (
            <Grid item xs={12} md={6} lg={3} key={index}>
              <ResCard
                cardClass="relative mb-10 w-[305px] h-[430px] object-cover bg-cream-100 rounded-md"
                iconClass="hidden"
                imgBg="bg-green-100 h-[280px]"
                bodyBg="bg-cream-100"
                imageSrc={
                  res.imgSrc ||
                  "https://mh-resources-production.s3.us-west-1.amazonaws.com/caf_podcast.jpg"
                }
                season={res.seasonNo}
                episode={res.episodeNo}
                title={res.title}
                length={res.length}
                titleUrl={`/podcasts/${res.slug}`}
                playUrl={`/podcasts/${res.slug}`}
                releaseDate={dayjs(res.releaseDate).format("MMMM D")} // Use res.startTime directly
              />
            </Grid>
          ))}
        </Slider>
      </Box>

      {/* For Web */}
      <Box className="mx-auto pt-10 bg-white px-4 md:px-20 py-4 hidden md:block">
        <Typography
          variant="h1"
          color="primary"
          className="font-areaSemi text-base md:text-xl text-center py-4"
        >
          Episodes You Might like
        </Typography>

        <Grid
          container
          spacing={2}
          className=" place-content-center place-items-center"
        >
          {currentPosts.map((res, index) => (
            <>
              <div className="hidden"> {(count = count + 1)}</div>

              {count === 11 ? (
                <Grid item xs={12} md={12} lg={6}>
                  <Zoom in style={{ transitionDelay: "200ms" }}>
                    <Card
                      className={`relative w-auto h-[474px] object-cover bg-green-100 rounded-md`}
                    >
                      <IconButton
                        disabled
                        className="absolute outline-none top-[6%] left-[5%]"
                      >
                        <Typography className=" capitalize font-areaSemi text-[15px] font-[900] leading-[92%] tracking-[0.1rem] text-white">
                          Podcast Play
                        </Typography>
                      </IconButton>
                      <Box className="  absolute top-[10%] left-[6%] z-50 drop-shadow-md">
                        <Typography className="text-left capitalize line-clamp-3 w-[70%] font-areaSemi text-[22px] leading-[150%] tracking-[-0.04rem] font-[600] text-white">
                          {res.title}
                        </Typography>

                        <Box className="pt-12 text-left space-x-4 absolute z-50">
                          <Link
                            to={`${location.pathname}/${res.slug}
       `}
                            className="bg-white w-[108px] no-underline  px-6 py-4 h-[45px] text-navy-900 font-areaSemi not-italic text-[12px] font-[700] leading-[102%] tracking-[0.05rem]"
                          >
                            Listen
                          </Link>
                        </Box>
                      </Box>
                      <CardMedia
                        className="object-cover absolute bottom-0 h-full"
                        component="img"
                        // image={res.thumbNailImageSrc}
                        image="https://res.cloudinary.com/mother-honestly/image/upload/v1678875641/pod_zp5lpj.jpg"
                        alt="Resource Image"
                      />
                    </Card>
                  </Zoom>
                </Grid>
              ) : count !== 11 ? (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  lg={3}
                  key={index}
                  className="cardozo md:px-3"
                >
                  <ResCard
                    cardClass="relative mb-10 w-[305px] h-[430px] object-cover bg-cream-100 rounded-md"
                    iconClass="hidden"
                    imgBg="bg-green-100 h-[280px]"
                    bodyBg="bg-cream-100"
                    imageSrc={
                      res.imgSrc ||
                      "https://mh-resources-production.s3.us-west-1.amazonaws.com/caf_podcast.jpg"
                    }
                    season={res.seasonNo}
                    episode={res.episodeNo}
                    title={res.title}
                    length={res.length}
                    titleUrl={`/podcasts/${res.slug}`}
                    playUrl={`/podcasts/${res.slug}`}
                    releaseDate={dayjs(res.releaseDate).format("MMMM D")} // Use res.startTime directly
                  />
                </Grid>
              ) : null}
            </>
          ))}
        </Grid>
      </Box>
      <Box className="hidden md:block">
        <Pagination
          totalPosts={podcastData.length}
          postsPerPage={postsPerPage}
          onClick={() => {
            setCurrentPage(currentPage - 1);
          }}
          onClicked={() => {
            setCurrentPage(currentPage + 1);
          }}
          currentPage={currentPage}
        />
      </Box>
      <PodcastSubscribe />
      <MHSubscribe />
      <MHFooter />
    </Fragment>
  );
};

export default PodcastsPage;
